(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["betteralt-uk-announcement-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('betteralt-uk-announcement-marquee')) {
  customElements.define('betteralt-uk-announcement-marquee', class extends HTMLElement {
    connectedCallback() {
      this.original = this.querySelector('[data-original]');
      this.track = this.querySelector('.bauk__track');
      this.viewport = this.querySelector('.bauk__viewport');
      if (!this.original) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('.bauk__pause')?.addEventListener('click', (event) => {
        const paused = this.toggleAttribute('data-paused');
        const button = event.currentTarget;
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        this.setAttribute('data-editing', '');
        this.viewport.scrollLeft = Math.max(0, event.target.offsetLeft - this.original.offsetLeft);
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.removeAttribute('data-editing');
        this.viewport.scrollLeft = 0;
      }, options);
      this.observer = new ResizeObserver(() => this.schedule());
      this.observer.observe(this.viewport);
      this.original.querySelectorAll('img').forEach(image => image.addEventListener('load', () => this.schedule(), options));
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.build());
    }
    duplicate(element) {
      const clone = element.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-clone', '');
      clone.removeAttribute('data-original');
      [clone, ...clone.querySelectorAll('*')].forEach(node => {
        node.removeAttribute('id');
        Array.from(node.attributes).forEach(attribute => {
          if (attribute.name.startsWith('data-shopify')) node.removeAttribute(attribute.name);
        });
      });
      clone.querySelectorAll('a, button, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
      return clone;
    }
    build() {
      this.removeAttribute('data-ready');
      this.track.querySelectorAll('.bauk__group:not([data-original])').forEach(node => node.remove());
      this.original.querySelectorAll('[data-clone]').forEach(node => node.remove());
      const items = Array.from(this.original.children);
      if (!items.length || !this.viewport.clientWidth) return;
      const width = this.original.getBoundingClientRect().width;
      if (!width) return;
      const repeats = Math.ceil(this.viewport.clientWidth / width);
      for (let index = 1; index < repeats; index++) {
        items.forEach(item => this.original.append(this.duplicate(item)));
      }
      this.track.append(this.duplicate(this.original));
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["betteralt-uk-stats-marquee"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('betteralt-uk-stats-marquee')) {
  customElements.define('betteralt-uk-stats-marquee', class extends HTMLElement {
    connectedCallback() {
      this.original = this.querySelector('[data-original]');
      this.track = this.querySelector('.buks__track');
      this.viewport = this.querySelector('.buks__viewport');
      if (!this.original) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelector('.buks__pause')?.addEventListener('click', (event) => {
        const paused = this.toggleAttribute('data-paused');
        const button = event.currentTarget;
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      }, options);
      this.addEventListener('shopify:block:select', (event) => {
        this.setAttribute('data-editing', '');
        this.viewport.scrollLeft = Math.max(0, event.target.offsetLeft - this.original.offsetLeft);
      }, options);
      this.addEventListener('shopify:block:deselect', () => {
        this.removeAttribute('data-editing');
        this.viewport.scrollLeft = 0;
      }, options);
      this.observer = new ResizeObserver(() => this.schedule());
      this.observer.observe(this.viewport);
      this.original.querySelectorAll('img').forEach(image => image.addEventListener('load', () => this.schedule(), options));
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }
    schedule() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.build());
    }
    duplicate(element) {
      const clone = element.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('data-clone', '');
      clone.removeAttribute('data-original');
      [clone, ...clone.querySelectorAll('*')].forEach(node => {
        node.removeAttribute('id');
        Array.from(node.attributes).forEach(attribute => {
          if (attribute.name.startsWith('data-shopify')) node.removeAttribute(attribute.name);
        });
      });
      clone.querySelectorAll('a, button, [tabindex]').forEach(node => node.setAttribute('tabindex', '-1'));
      return clone;
    }
    build() {
      this.removeAttribute('data-ready');
      this.track.querySelectorAll('.buks__group:not([data-original])').forEach(node => node.remove());
      this.original.querySelectorAll('[data-clone]').forEach(node => node.remove());
      const items = Array.from(this.original.children);
      if (!items.length || !this.viewport.clientWidth) return;
      const width = this.original.getBoundingClientRect().width;
      if (!width) return;
      const repeats = Math.max(5, Math.ceil(this.viewport.clientWidth / width));
      for (let index = 1; index < repeats; index++) {
        items.forEach(item => this.original.append(this.duplicate(item)));
      }
      this.track.append(this.duplicate(this.original));
      this.setAttribute('data-ready', '');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.abort?.abort();
      cancelAnimationFrame(this.frame);
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
